import { CollapsableCompanionChartType } from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import { useFillsGraphConfigurationSelector } from 'widgets/fillsGraph/store/configuration/selectors';

export function useShowCollapsableCompanionChart(
    section: CollapsableCompanionChartType
) {
    const config = useFillsGraphConfigurationSelector();
    return !config[section].collapsed;
}
